/**
 * Shared client-side form validation helpers.
 */

// Standard email shape: local-part@domain.tld — kept permissive but rejects
// obvious non-emails so callers can gate submit buttons on a plausible address.
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** Returns true when `value` looks like a plausible email address (trimmed). */
export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim())
}
